import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
export const routes: Routes = [
    {
        path: '',
        redirectTo: 'app/loading',
        pathMatch: 'full',
    },
    {
        path: 'app/loading',
        // canActivate: [AuthGuard],
        loadComponent: () =>
            import('./components/loading/loading.component').then(
                m => m.LoadingComponent
            ),
    },
    {
        path: 'app/login',
        loadComponent: () =>
            import('./components/login/login.component').then(
                m => m.LoginComponent
            ),
    },
    {
        path: 'app/home',
        canActivate: [AuthGuard],
        loadComponent: () =>
            import('./components/home/home.component').then(
                m => m.HomeComponent
            ),
    },
        {
        path: 'app/codeset',
        canActivate: [AuthGuard],
        loadComponent: () =>
            import('./components/codeset/codeset.component').then(
                m => m.CodesetComponent
            ),
    },
    {
        path: 'app/help',
        canActivate: [AuthGuard],
        loadComponent: () =>
            import('./components/help-manual/help-manual.component').then(
                m => m.HelpManualComponent
            ),
    },
    {
        path: 'app/tickets',
        canActivate: [AuthGuard],
        loadComponent: () =>
            import('./components/tickets/tickets.component').then(
                m => m.TicketsComponent
            ),
    },
    {
        path: 'login',
        loadComponent: () =>
            import('./components/login/login.component').then(
                m => m.LoginComponent
            ),
    },
    {
        path: '**',
        redirectTo: '/app/loading',
        pathMatch: 'full',
    },
];
